import { render, staticRenderFns } from "./SingleVSMultiple.vue?vue&type=template&id=aa489710&"
import script from "./SingleVSMultiple.vue?vue&type=script&lang=js&"
export * from "./SingleVSMultiple.vue?vue&type=script&lang=js&"
import style0 from "./SingleVSMultiple.vue?vue&type=style&index=0&id=aa489710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports